export default {
  logIn: {
    en: 'Log in',
  },
  buttonTitle: {
    en: 'Get started',
  },
}
